import { Box, Typography, Button } from '@mui/material'
import { useRouter } from 'next/router';
import React from 'react'


type Props = {}

export default function request({ }: Props) {
    const router = useRouter();
    const handletoContact = () => {
        router.push("../contact");
    }
    return (
        <>
            <Box
                sx={{
                    backgroundColor: "#F5F6F8",
                    height: "auto",
                    width: "100%",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "12px"
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'NotoSansThai-SemiBold',
                        fontSize: "18px",
                        mt: "50px"
                    }}
                >
                    ฝ่ายบริการลูกค้าสัมพันธ์
                </Typography>
                <Typography
                    sx={{
                        fontSize: "14px",
                        mb: "50px"
                    }}
                >
                    โทร 094-349-3991 (เวลา 09.00-18.00น. วันจันทร์-ศุกร์ ไม่รวมวันหยุดนักขัตฤกษ์)
                    {/* หรือกรอกแบบฟอร์มคำร้องเพื่อให้ติดต่อกลับ */}
                </Typography>
                <Button
                    onClick={handletoContact}
                    variant="outlined"
                    sx={{
                        borderColor: "#DB5A00",
                        bgcolor: "#DB5A00",
                        '&:hover': {
                            borderColor: "#b34a00",
                            bgcolor: "#b34a00"
                        },
                        color: "#FFFFFF",
                        mt: 3,
                        mb: 3
                    }}
                >
                    กรอกแบบฟอร์ม
                </Button>

            </Box>
        </>
    )
}